import { Colors } from '@zapier/design-system';
import { COLOR_KEYS } from '../../../constants';

export const SECTIONS = [
  {
    navLinkText: 'Section 1',
    heading: `Connect your apps, <span style="color: ${Colors.zapier}">automate your work</span>`,
    description:
      '<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>',
    animationDataUrl:
      'https://assets3.lottiefiles.com/private_files/lf30_pbxec3cw.json',
  },
  {
    navLinkText: 'Section 2',
    heading: `Connect your apps, <span style="color: ${Colors.zapier}">automate your work</span>`,
    description:
      '<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>',
    animationDataUrl:
      'https://assets3.lottiefiles.com/packages/lf20_2r60fbgn.json',
  },
  {
    navLinkText: 'Section 3',
    heading: `Connect your apps, <span style="color: ${Colors.zapier}">automate your work</span>`,
    description:
      '<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>',
    animationDataUrl:
      'https://assets7.lottiefiles.com/packages/lf20_wvgjjcbq.json',
  },
  {
    navLinkText: 'Section 4',
    heading: `Connect your apps, <span style="color: ${Colors.zapier}">automate your work</span>`,
    description:
      '<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>',
    animationDataUrl:
      'https://assets3.lottiefiles.com/packages/lf20_2cyedfbj.json',
  },
  {
    navLinkText: 'Section 5',
    heading: `Connect your apps, <span style="color: ${Colors.zapier}">automate your work</span>`,
    description:
      '<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>',
    animationDataUrl:
      'https://assets10.lottiefiles.com/packages/lf20_hcae8wxn.json',
  },
];

export const DEFAULT_VALUES = {
  title: 'Animation party',
  backgroundColor: COLOR_KEYS.neutral100,
  sections: [
    {
      navLinkText: 'Time',
      heading:
        '<p>It\'s <span style="color: var(--zds-colors-zapier, #ff4f00);">5 o\'clock </span><span style="color: rgb(0, 0, 0);">somewhere!</span></p>',
      description:
        '<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>',
      animationDataUrl:
        'https://assets3.lottiefiles.com/private_files/lf30_pbxec3cw.json',
      mediaAltText: 'Time passing on a clock',
    },
    {
      navLinkText: 'Bunny',
      heading:
        '<p>This <span style="color: var(--zds-colors-zapier, #ff4f00);">little bunny </span><span style="color: rgb(0, 0, 0);">needs a drink</span></p>',
      description:
        '<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>',
      animationDataUrl:
        'https://assets3.lottiefiles.com/packages/lf20_2r60fbgn.json',
      mediaAltText:
        'A bunny rabbit drinking a bottle of rainbow colored liquid in a drunken fashion',
    },
    {
      navLinkText: 'Too much?',
      heading:
        '<p>Oh no! Too much <span style="color: rgb(255, 79, 0);">rainbow juice</span>?</p>',
      description:
        '<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>',
      animationDataUrl:
        'https://assets7.lottiefiles.com/packages/lf20_wvgjjcbq.json',
      mediaAltText: 'Pink pony looking worried',
    },
    {
      navLinkText: 'Nah!',
      heading:
        '<p>No such thing as <span style="color: rgb(255, 79, 0);">too much </span><span style="color: rgb(0, 0, 0);">rainbow</span><span style="color: rgb(255, 79, 0);"> </span><span style="color: rgb(0, 0, 0);">juice</span></p>',
      description:
        '<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>',
      animationDataUrl:
        'https://assets3.lottiefiles.com/packages/lf20_2cyedfbj.json',
      mediaAltText: 'Non-chalant beer bottle',
    },
    {
      navLinkText: 'Goodbye',
      heading:
        '<p>Owl <span style="color: rgb(255, 79, 0);">see you</span> later!</p>',
      description:
        '<p>Your trigger is what kicks off the automated process between your apps. In our example, the trigger is a lead coming in through Facebook.</p>',
      animationDataUrl:
        'https://assets5.lottiefiles.com/packages/lf20_fhMCjY.json',
      mediaAltText: 'Owl drinking wine and then keeling over',
    },
  ],
};
